import { render, staticRenderFns } from "./AdminClients.vue?vue&type=template&id=2e557802&lang=pug"
import script from "./AdminClients.vue?vue&type=script&lang=js"
export * from "./AdminClients.vue?vue&type=script&lang=js"
import style0 from "./AdminClients.vue?vue&type=style&index=0&id=2e557802&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports